import { GalleriesPageProps } from '~/components/GalleriesPage'

export interface GalleryCardViewModel {
  id: string
  title: string
  galleryUrl: string
  imageUrl?: string
  organizerAssetUrl?: string
  organizerName?: string
}

export interface GalleriesPageViewModel {
  htmlPageMetaContextProps: GalleriesPageProps['htmlPageMetaContextProps']
  cards: GalleryCardViewModel[]
}

export function fromGalleriesPagePropsToViewModel (props: GalleriesPageProps): GalleriesPageViewModel {
  const cards = props.profiles
    .map((profile) => {
      return {
        id: profile.id,
        title: profile.name,
        galleryUrl: profile.museumUrl as string,
        imageUrl: profile.avatarUrl,
        organizerAssetUrl: profile.organizerAssetUrl,
        organizerName: profile.organizerName,
      }
    })

  return {
    htmlPageMetaContextProps: props.htmlPageMetaContextProps,
    cards,
  }
}
